import { Exclamation } from "@components/Modals/BankRelinkModal/components";
import { RecurringContributionItem } from "@components/Modals/BankRelinkModal/components/RecurringContributionItem";
import { useStyles } from "@components/Modals/BankRelinkModal/styles";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H2 } from "@components/Typography";
import { useFailedAchContribution } from "@hooks";
import { i18n, Translations } from "@i18n";

export const ContributionFailed = () => {
  const styles = useStyles();
  const { contributionFailedSubtitle } = useFailedAchContribution();
  const { amount, date, hasSubtitle } = contributionFailedSubtitle;

  return (
    <>
      <Spacing size={SpacingSizes.M} />
      <Exclamation style={styles.exclamation} />
      <Spacing size={SpacingSizes.M} />
      <H2 style={styles.title}>{i18n.t(Translations.BankRelinkModalContributionFailedTitle)}</H2>
      <Spacing size={SpacingSizes.M} />
      {hasSubtitle ? (
        <Body style={styles.subtitle}>
          {i18n.t(Translations.BankRelinkModalContributionFailedSubtitle, {
            amount,
            date,
          })}
        </Body>
      ) : null}
      <Spacing size={SpacingSizes.M} />
      <RecurringContributionItem />
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
